import React, { useContext } from "react";
import { MUIBox, MUICircularProgress, tokens } from "@cobee/cobee-ui";
import CompanyContext from "../../../infrastructure/Contexts/components/data/CompanyWrapper/context";
import BenefitPlansContext from "../../../infrastructure/Contexts/components/data/BenefitPlanWrapper/context";

export default function LoaderProvider({
  children,
}: {
  children: JSX.Element;
}) {
  const { isLoading: companyIsLoading } = useContext(CompanyContext);
  const { isLoading: benefitPlansAreLoading } = useContext(BenefitPlansContext);

  if (companyIsLoading || benefitPlansAreLoading) {
    return (
      <>
        <MUIBox
          sx={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <MUICircularProgress sx={{ color: tokens.palette.secondary.main }} />
        </MUIBox>
      </>
    );
  }
  return children;
}
